import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://envbaxccpkuovfwxjvyb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVudmJheGNjcGt1b3Zmd3hqdnliIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzODgwMTksImV4cCI6MjA3Nzk2NDAxOX0.Z9e4z-qaWcXdH-LwEvhAP2aQiW3uXlJSnnghDeLt4EQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types
export interface Contact {
  id: string;
  name: string;
  email: string;
  subject?: string;
  message: string;
  status: string;
  created_at: string;
}

export interface Post {
  id: string;
  title: string;
  slug: string;
  excerpt?: string;
  content: string;
  cover_image?: string;
  category?: string;
  tags?: string[];
  published: boolean;
  views: number;
  created_at: string;
  updated_at: string;
}

export interface Project {
  id: string;
  title: string;
  slug: string;
  description: string;
  category: string;
  tech_stack: string[];
  preview_image?: string;
  live_demo_url?: string;
  github_url?: string;
  featured: boolean;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export interface Stat {
  id: string;
  metric_name: string;
  metric_value: number;
  metric_label?: string;
  icon?: string;
  updated_at: string;
}

export interface ProfileSettings {
  id: string;
  user_id: string;
  profile_photo_url?: string;
  tagline?: string;
  bio?: string;
  cv_url?: string;
  social_links?: any;
  updated_at: string;
}
